export const CONFIG_WEB = {
	apiKey: 'ixiweb!2$',
	clientId: 'ixiweb',
};

export const CONFIG_MOBILE = {
	apiKey: 'iximweb!2$',
	clientId: 'iximweb',
};

export const WEB_CLIENTS = [CONFIG_WEB.clientId, CONFIG_MOBILE.clientId];

export function isForeignEnvironment(clientId: string) {
	return clientId && !WEB_CLIENTS.includes(clientId);
}

export function quit(): boolean {
	if (window.IxiWebView?.quit) {
		window.IxiWebView.quit();
		return true;
	}
	if (window.webkit?.messageHandlers?.appInterface) {
		window.webkit.messageHandlers.appInterface.postMessage('quit');
		return true;
	}
	return false;
}

export function configureUI(uiConfig: IxigoSDKUIConfig): Promise<unknown> {
	const sdk = window.IxigoSDK?.ui;
	if (!sdk) return Promise.reject(new Error('IxigoSDK.ui unavailable'));
	return sdk.configure(uiConfig);
}

/**
 * hides the overlay loader displayed by native webview
 * call it when web page is ready with themes and initial view
 */
export function onReady(): void {
	if (window.IxiWebView?.pwaReady) {
		window.IxiWebView.pwaReady();
	} else if (window.webkit?.messageHandlers?.appInterface) {
		window.webkit.messageHandlers.appInterface.postMessage('pwaReady');
	}
}
